import { List } from 'immutable'
import moment from 'moment'
import React from 'react'
import './table.sass'

function Header(props) {
  let { columns } = props

  return (
    <div className="table-header">
      <div className="table-row table-row--header">
        {columns.map(cell => {
          let { label, key, align, width } = cell
          let style = {}
          if (width) style.width = `${width}px`

          let classes = ['table-cell', 'table-cell--header']
          if (align) classes.push(`table-cell--align-${align}`)

          return (
            <div className={classes.join(' ')} style={style} key={key}>
              <span>{label}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

function Rows(props) {
  let { columns, id: idKey = '', rows, t } = props

  if (!rows.size) return null

  return (
    <div className="table-body">
      {rows.map(item => {
        let id = item.getIn(idKey.split('.'), false)
        if (!id) return null
        return (
          <div className="table-row table-row--body" key={id}>
            {columns.map(cell => {
              let { key, render, date = false, align = false, width = false, maxWidth = false, size } = cell

              let value
              if (typeof render === 'function') value = render(item, t)
              else value = item.getIn(key.split('.'), '')

              if (date) {
                let format = typeof date === 'string' ? date : 'l LT'
                value = moment(value).format(format)
                if (value === 'Invalid data' || value === 'Invalid date') value = ''
              }

              let style = {}
              if (width) style.width = `${width}px`
              if (maxWidth) style.maxWidth = `${maxWidth}px`

              let classes = ['table-cell']
              if (align) classes.push(`table-cell--align-${align}`)

              if (size) classes.push(`table-cell--size-${size}`)

              return (
                <div className={classes.join(' ')} style={style} key={key}>
                  {value}
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

export default function Table({ columns, rows, emptyText, id }) {
  let itemProps = {
    columns,
    rows,
    id,
  }

  if (!List.isList(rows)) return null

  return (
    <div className="table-wrapper">
      <div className="table-scroll">
        <div className="table-scroll-inner">
          <div className="table">
            <Header {...itemProps} />
            <Rows {...itemProps} />
          </div>
          {!itemProps.rows.size ? <div className="table-empty">{emptyText || 'No results'}</div> : null}
        </div>
      </div>
    </div>
  )
}
